import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: [],

	//✅ Loading States
	organisationLoading: false,
	organisationLoadingComplete: false,
	loadingCreateOrganisation: false,

	//delete Organisation loading state
	deleteOrganisationLoading: false,

	//update Organisation loading state
	updateOrganisationLoading: false,

	//✅ Complete States
	completeAddOrganisation: false,
	error: null
};

const organisationSlice = createSlice({
	name: 'Organisations',
	initialState,
	reducers: {
		loadOrganisations: (state) => {
			state.organisationLoading = true;
			state.error = null;
		},
		loadOrganisationsSuccess: (state, action) => {
			state.data = action.payload;
			state.organisationLoading = false;
			state.organisationLoadingComplete = true;
		},
		loadOrganisationsError: (state, action) => {
			state.organisationLoading = false;
			state.error = action.payload;
		},
		createOrganisation: (state) => {
			state.loadingCreateOrganisation = true;
			state.completeAddOrganisation = false;
			state.error = null;
		},
		createOrganisationSuccess: (state) => {
			state.loadingCreateOrganisation = false;
			state.completeAddOrganisation = true;
			state.error = null;
		},
		createOrganisationError: (state, action) => {
			state.loadingCreateOrganisation = false;
			state.completeAddOrganisation = false;
			state.error = action.payload;
		},
		deleteOrganisation: (state) => {
			state.deleteOrganisationLoading = true;
			state.error = null;
		},
		deleteOrganisationSuccess: (state) => {
			state.deleteOrganisationLoading = false;
			state.error = null;
		},
		deleteOrganisationError: (state, action) => {
			state.deleteOrganisationLoading = false;

			state.error = action.payload;
		},
		updateOrganisation: (state, action) => {
			state.updateOrganisationLoading = true;
			state.error = null;
		},
		updateOrganisationSuccess: (state, action) => {
			state.updateOrganisationLoading = false;
			state.error = null;
			if (action.payload?.orgID && action.payload?.data) {
				const { orgID, data } = action.payload;
				const orgIndex = state.data.findIndex(org => org.orgID === orgID);
				if (orgIndex !== -1) {
					state.data[orgIndex] = { ...state.data[orgIndex], ...data };
				}
			}
		},
		updateOrganisationError: (state, action) => {
			state.updateOrganisationLoading = false;
			state.error = action.payload;
		}
	},
	extraReducers: (builder) => {
		// Add extra reducers here
		builder.addCase('auth/logout', () => {
			return initialState;
		});
	}
});

export const organisationActions = organisationSlice.actions;

export default organisationSlice.reducer;
